export const formatError = (error: any) => {
  const msg = (error?.message === 'Error' ? '' : error?.message) || error?.errorCode || error?.toString() || ''
  if (msg.toLowerCase().includes('user rejected the request')) return 'User denied transaction signature.'
  return msg
}

// use this class if you don't want Sentry capture error
export class CustomError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'OptimexCustomError'
  }
}
